import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { get_opportunity } from "../../../services/apis/opportunity";
import { useAppDispatch, useAppSelector } from "../../../store";
import EditOportunity from "../misc/EditOportunity";
import Button from "../../../component/element/forms/Button";

const EditOpportunityPage: React.FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const opportunity = useAppSelector((state) => state.opportunity.opportunity);
  const loading = useAppSelector((state) => state.opportunity.loading);

  React.useEffect(() => {
    if (id) get_opportunity(dispatch, id);
  }, [dispatch, id]);

  if (!opportunity || opportunity.id !== id) {
    return (
      <div className="py-12 text-center text-gray-500">
        {loading ? (
          "Loading opportunity..."
        ) : (
          <>
            <p className="mb-4">Opportunity could not be loaded.</p>
            <Button
              title="Back to opportunities"
              onClick={() => navigate("/opportunity")}
            />
          </>
        )}
      </div>
    );
  }

  return (
    <EditOportunity
      show
      opportunity={opportunity}
      onHandler={() => navigate("/opportunity")}
    />
  );
};

export default EditOpportunityPage;
